import { render, staticRenderFns } from "./Secure.vue?vue&type=template&id=d10c5278&scoped=true"
import script from "./Secure.vue?vue&type=script&lang=js"
export * from "./Secure.vue?vue&type=script&lang=js"
import style0 from "./Secure.vue?vue&type=style&index=0&id=d10c5278&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d10c5278",
  null
  
)

export default component.exports